import { getMessaging, getToken, isSupported } from "firebase/messaging";
import Swal from "sweetalert2";
/* ================= TOAST ================= */
const Toast = Swal.mixin({
    toast: true,
    showConfirmButton: false,
    timer: 10000,
    timerProgressBar: true,
});
const ToastShow = (type, message) =>
    Toast.fire({ icon: type, title: message });
export const requestPushPermission = async () => {
  const supported = await isSupported();

  if (!supported) {
      ToastShow(
          "info",
          "Push notifications not supported on this browser. Please use Chrome or install the app."
      );
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const messaging = getMessaging();

  return await getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, // CRA
  });
};
